import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {LanguageService} from '.././../services/language.service'
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  navbarOpen = false;
  currentLanguage: string;
  constructor(private router: Router, public languageService: LanguageService) { 
    this.currentLanguage = languageService.getCurrentLanguage();

  }

  changeLanguage(lang: string) {
    this.languageService.setLanguage(lang);
    this.currentLanguage = lang;
    
  }
  showMenu = false;
  toggleNavbar(){
    this.showMenu = !this.showMenu;
  }
  ngOnInit(): void {

  }

  isCurrentRoute(route: string): boolean {
    return this.router.url === route;
  }
  setNavbarOpen() {
    this.navbarOpen = !this.navbarOpen;
  }

  move(){
    this.router.navigate(["/FAQs"])

  }
}
